var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { removeJobFilter } from '@/api';
import { useJobsContext } from '@/hoc';
import { useMutation } from '@/hooks';
import React, { useCallback } from 'react';
import { DeleteConfirmationModal } from '../delete-conformation';
import { DeleteIcon } from '../icons';
import { Button, Text } from '../ui';
import { SaveFilterForm } from './save-filter-form';
var SavedFiltersSection = function (_a) {
    var savedFilters = _a.savedFilters, refetchSaveJobFilters = _a.refetchSaveJobFilters, filterCriteria = _a.filterCriteria, _b = _a.showSaveSection, showSaveSection = _b === void 0 ? false : _b, setShowSaveSection = _a.setShowSaveSection, setShowDeleteModal = _a.setShowDeleteModal, showDeleteModal = _a.showDeleteModal, _c = _a.className, className = _c === void 0 ? '' : _c;
    var _d = useJobsContext(), setFilters = _d.setFilters, filters = _d.filters;
    var isFilterApplied = useCallback(function (savedFilter) {
        var _a;
        var appliedFilters = (filters === null || filters === void 0 ? void 0 : filters.appliedFilters) || [];
        if (!(appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.length)) {
            return false;
        }
        return (_a = savedFilter === null || savedFilter === void 0 ? void 0 : savedFilter.selected_filters) === null || _a === void 0 ? void 0 : _a.every(function (selected) {
            var matchingAppliedFilters = appliedFilters === null || appliedFilters === void 0 ? void 0 : appliedFilters.filter(function (app) { return app.queryKey === selected.filterType; });
            if ((matchingAppliedFilters === null || matchingAppliedFilters === void 0 ? void 0 : matchingAppliedFilters.length) === 0)
                return false;
            if (selected.value instanceof Array) {
                return selected.value.every(function (value) {
                    return matchingAppliedFilters.some(function (filter) { return filter.value.toString() === value.toString(); });
                });
            }
            return matchingAppliedFilters.some(function (filter) { return filter.value.toString() === selected.value.toString(); });
        });
    }, [filters.appliedFilters]);
    var handleSavedFilterSelect = useCallback(function (savedFilter) {
        var appliedFilters = (filters === null || filters === void 0 ? void 0 : filters.appliedFilters) || [];
        var newFiltersToApply = __spreadArray([], appliedFilters, true);
        savedFilter.selected_filters.forEach(function (selected) {
            var _a, _b, _c, _d;
            var filterToApply = filterCriteria.find(function (f) {
                return f.inputType !== 'custom'
                    ? f.queryName === selected.filterType
                    : f.queryName.split(',')[0] === selected.filterType ||
                        f.queryName.split(',')[1] === selected.filterType;
            });
            if ((filterToApply === null || filterToApply === void 0 ? void 0 : filterToApply.inputType) === 'checkbox') {
                var values_1 = (_a = (Array.isArray(selected.value) ? selected.value : [selected.value])) === null || _a === void 0 ? void 0 : _a.map(String);
                var filterOptionsToApply = filterToApply === null || filterToApply === void 0 ? void 0 : filterToApply.options.filter(function (option) {
                    return values_1.includes(option.id.toString());
                });
                var value_1 = filterOptionsToApply.map(function (option) { return option.id; });
                var options = (_b = filterCriteria.find(function (f) { return f.queryName === selected.filterType; })) === null || _b === void 0 ? void 0 : _b.options.filter(function (option) { return value_1.includes(option.id); });
                newFiltersToApply = __spreadArray(__spreadArray([], newFiltersToApply.filter(function (f) { return !(f.queryKey === selected.filterType && (value_1 === null || value_1 === void 0 ? void 0 : value_1.includes(f.value.toString()))); }), true), (options || []).map(function (option) { return ({
                    queryKey: selected.filterType,
                    label: option.name,
                    value: option.id,
                }); }), true);
            }
            if ((filterToApply === null || filterToApply === void 0 ? void 0 : filterToApply.inputType) === 'slider') {
                newFiltersToApply = __spreadArray(__spreadArray([], newFiltersToApply.filter(function (f) { return f.queryKey !== selected.filterType; }), true), [
                    {
                        queryKey: selected.filterType,
                        value: Number(selected.value),
                        label: "Exp: ".concat(selected.value, " Years"),
                    },
                ], false);
            }
            if ((filterToApply === null || filterToApply === void 0 ? void 0 : filterToApply.inputType) === 'custom') {
                var _e = selected.filterType.split(','), minKey_1 = _e[0], maxKey_1 = _e[1];
                var minValue = (_c = newFiltersToApply.find(function (filter) { return filter.queryKey === minKey_1; })) === null || _c === void 0 ? void 0 : _c.value;
                var maxValue = (_d = newFiltersToApply.find(function (filter) { return filter.queryKey === maxKey_1; })) === null || _d === void 0 ? void 0 : _d.value;
                if (maxValue && minValue && minValue > maxValue) {
                    newFiltersToApply = newFiltersToApply.filter(function (f) { return f.queryKey !== maxKey_1; });
                }
                if (selected.filterType === minKey_1) {
                    newFiltersToApply = __spreadArray(__spreadArray([], newFiltersToApply.filter(function (filter) { return filter.queryKey !== minKey_1; }), true), [
                        {
                            queryKey: minKey_1,
                            value: Number(selected.value),
                            label: "Min-Sal: ".concat(selected.value, " PA"),
                        },
                    ], false);
                }
                if (selected.filterType === maxKey_1) {
                    newFiltersToApply = __spreadArray(__spreadArray([], newFiltersToApply.filter(function (filter) { return filter.queryKey !== maxKey_1; }), true), [
                        {
                            queryKey: maxKey_1,
                            value: Number(selected.value),
                            label: "Max-Sal: ".concat(selected.value, " PA"),
                        },
                    ], false);
                }
            }
        });
        setFilters(function (prevFilters) { return (__assign(__assign({}, prevFilters), { appliedFilters: newFiltersToApply })); });
    }, [filterCriteria, filters === null || filters === void 0 ? void 0 : filters.appliedFilters, setFilters]);
    var mutate = useMutation({
        mutationFn: function (filterPayload) { return removeJobFilter(filterPayload); },
        onSuccess: function () {
            setShowDeleteModal(false);
            refetchSaveJobFilters();
        },
    }).mutate;
    var handleDelete = function (filterName) {
        mutate({ saved_filter_name: filterName });
    };
    return (_jsxs("div", { className: "w-full py-2 px-2 text-center border-b border-gray-200 ".concat(className), children: [showSaveSection && (_jsx(SaveFilterForm, { refetchSaveJobFilters: refetchSaveJobFilters, setShowSaveSection: setShowSaveSection })), savedFilters.length ? (_jsx("div", { className: 'flex gap-2 py-2 flex-wrap', children: savedFilters.map(function (filter) {
                    var isApplied = isFilterApplied(filter);
                    return (_jsxs(React.Fragment, { children: [_jsxs("div", { onClick: function () {
                                    if (!isApplied) {
                                        handleSavedFilterSelect(filter);
                                    }
                                }, className: "flex items-center cursor-pointer gap-2 px-4 py-1 rounded-full ".concat(isApplied ? 'bg-vjwPrimary text-white' : 'bg-gray-200 text-black'), children: [_jsx("span", { children: filter.saved_filter_name }), _jsx(Button, { variant: 'text', className: "px-0 py-0 ".concat(isApplied ? 'text-white' : 'text-vjwDanger'), onClick: function (e) {
                                            e.stopPropagation();
                                            setShowDeleteModal(true);
                                        }, children: _jsx(DeleteIcon, {}) })] }), showDeleteModal && (_jsx(DeleteConfirmationModal, { isOpen: showDeleteModal, onClose: function () { return setShowDeleteModal(false); }, onConfirm: function () { return handleDelete(filter.saved_filter_name); } }))] }, filter.saved_filter_name));
                }) })) : (_jsx(Text, { variant: 'description', className: 'py-8', children: "No Saved Filters" }))] }));
};
export default SavedFiltersSection;
